export default __webpack_public_path__ + "static/media/microsoft.19929264.svg";